import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import EventsActions from '../../Redux/EventsRedux'
import AdvancedTable from '../../Components/AdvancedTable'
import AdvancedFilter from '../../Components/AdvancedFilter'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import FormatMoney from '../../Utils/FormatMoney'

class ViewDetail extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'YYYY-MM-DD'
    this.state = {
      editMode: '',
      form: {
        description: props.props.description
      }
    }
  }

  _handleEditMode = (ID, action) => {
    this.setState({ editMode: ID })
    if (action === 'reset') {
      this.setState({ form: { description: this.props.props.description } })
    }
  }

  _handleChange = (event) => {
    let value = event.target.value
    let form = this.state.form
    form.description = value
    this.setState({ form: form })
  }

  _resetEventDescription = (event_id) => {
    let data = { event_id }
    this.props.resetEventDescription(data)
  }

  _updateEventDescription = (event_id) => {
    let data = {
      event_id,
      description: this.state.form.description
    }
    this.props.updateEventDescription(data)
    setTimeout(() => {
      this._handleEditMode('', null)
    }, 250)
  }

  render () {
    const { props } = this.props
    return (
      <section style={{ width: '75vw' }}>
        <header className='title-block'>
          <h1 className='title'>Event Details for {props.name}</h1>
        </header>
        <table className='table table-hover table-bordered'>
          <tbody>
            <tr>
              <td className='align-middle'>
                <h5>Banner</h5>
              </td>
              <td className='text-center'>
                <img src={props.banner} alt={props.banner} width='600px' />
              </td>
            </tr>
            <tr>
              <td className='align-middle'>
                <h5>Description</h5>
              </td>
              <td>
                <textarea
                  readOnly={this.state.editMode === ''}
                  style={{ minHeight: '25vh' }}
                  className='form-control'
                  value={this.state.form.description}
                  onChange={(event) => this._handleChange(event)}
                />
                <div className='text-right mt-3'>
                  {
                    props.is_ignored_on_update === true &&
                    <button disabled={this.state.editMode === 'editing'} className='btn btn-primary mr-2' onClick={() => this._resetEventDescription(props.event_id)}>
                      <i className='fa fa-sync' /> Revert Description
                    </button>
                  }
                  {
                    this.state.editMode === '' &&
                    <button className='btn btn-primary' onClick={() => this._handleEditMode('editing', null)}>
                      <i className='fa fa-edit' /> Edit Description
                    </button>
                  }
                  {
                    this.state.editMode === 'editing' &&
                    <button className='btn btn-danger mr-2' onClick={() => this._handleEditMode('', 'reset')}>
                      <i className='fa fa-times' /> Cancel Edit
                    </button>
                  }
                  {
                    this.state.editMode === 'editing' &&
                    <button className='btn btn-primary' onClick={() => this._updateEventDescription(props.event_id)}>
                      <i className='fa fa-upload' /> Save Changes
                    </button>
                  }
                </div>
              </td>
            </tr>
            <tr>
              <td className='align-middle'>
                <h5>Schedule Info</h5>
              </td>
              <td>
                <table className='table table-bordered table-hover table-striped'>
                  <tbody>
                    <tr>
                      <td><strong>Start Date</strong></td>
                      <td>{props.schedules && moment(props.schedules[0].start_date).format(this.dateFormat)}</td>
                    </tr>
                    <tr>
                      <td><strong>End Date</strong></td>
                      <td>{props.schedules && moment(props.schedules[0].end_date).format(this.dateFormat)}</td>
                    </tr>
                    <tr>
                      <td><strong>Location</strong></td>
                      <td>{props.schedules && props.schedules[0].location.location_name}</td>
                    </tr>
                    <tr>
                      <td><strong>Address</strong></td>
                      <td>{props.schedules && props.schedules[0].location.address}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td className='align-middle'>
                <h5>Additional Info</h5>
              </td>
              <td>
                <table className='table table-bordered table-hover table-striped'>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Privacy</th>
                      <th>Membership</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <ul>
                          {
                            props.categories && props.categories.length > 0
                              ? props.categories.map((li, i) => (
                                <li key={i}>{li.name} ({li.status ? 'Active' : 'Inactive'})</li>
                              ))
                              : <li>No assigned category</li>
                          }
                        </ul>
                      </td>
                      <td>{props.is_private_event ? 'Private' : 'Public'}</td>
                      <td>{props.required_member ? 'Required' : 'Not required'}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div className='row'>
          <div className='col-12 text-right'>
            <button type='button' className='btn btn-primary' onClick={() => this.props.closeModal()}>Close</button>
          </div>
        </div>
      </section>
    )
  }
}

class EventsList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {
        schedules: []
      },
      q: '',
      page: 1
    }
  }

  componentDidMount = () => {
    this._fetchAllEvents()
  }

  _fetchAllEvents = (event) => {
    if (event) event.preventDefault()
    let filter = {}
    if (this.state.q) {
      filter = {
        page: 1,
        q: this.state.q
      }
    } else {
      filter = {
        page: this.state.page,
        q: ''
      }
    }
    this.props.getAllEvents(filter)
  }

  _manipulateState = (props) => {
    this.setState({ q: props.q })
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _toggleDetail = (detail) => {
    this.setState({ detail })
  }

  _toggleModal = (detail, modalId = null) => {
    this._toggleDetail(detail)
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchAllEvents()
    }
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => {
      this._fetchAllEvents()
    }, 250)
  }

  _resetEventDescription = (data) => {
    this.props.resetEventDescription(data)
  }

  _updateEventDescription = (data) => {
    this.props.updateEventDescription(data)
  }

  render () {
    const { events } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Events List
              {
                (events.fetching || events.processing) &&
                <div className='badge badge-info ml-2'>{ events.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
          </div>
          <AdvancedFilter
            filters={[
              {
                type: 'text',
                name: 'Name',
                placeholder: 'Insert event name ...',
                field: 'q'
              }
            ]}
            manipulateState={(props) => this._manipulateState(props)}
            callback={(event) => this._fetchAllEvents(event)}
          />
        </header>
        {
          !(events.fetching || events.processing) && events.err && <div className='alert alert-danger'>{events.err}</div>
        }
        <AdvancedTable
          colSpan={5}
          header={[
            { field: 'Event Name', className: 'text-left' },
            { field: 'Organizer' },
            { field: 'Capacity' },
            { field: 'Price' },
            { field: 'View Details' }
          ]}
          body={
            events.data.data &&
            events.data.data.length > 0 &&
            events.data.data.map(item => ([
              { field: item.name, className: 'text-left' },
              { field: item.organization_name },
              { field: item.capacity },
              { field: FormatMoney(item.start_price) },
              {
                field: <button className='btn btn-primary' onClick={() => this._toggleModal(item, 'view-detail')}>
                  <i className='fa fa-eye' />
                </button>
              }
            ]))
          }
        />
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-detail'} onClose={() => this._toggleModal({}, null)}>
          <ViewDetail
            props={this.state.detail}
            resetEventDescription={(data) => this._resetEventDescription(data)}
            updateEventDescription={(data) => this._updateEventDescription(data)}
            closeModal={() => this._toggleModal({}, null)}
          />
        </Modal>
        <section className='text-center'>
          {
            (events.data && events.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={events.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={events.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  events: state.events
})

const dispatchToProps = (dispatch) => ({
  getAllEvents: (filter) => dispatch(EventsActions.getAllEventsRequest(filter)),
  updateEventDescription: (data) => dispatch(EventsActions.updateEventDescriptionRequest(data)),
  resetEventDescription: (data) => dispatch(EventsActions.resetEventDescriptionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(EventsList)



// WEBPACK FOOTER //
// ./src/Pages/Events/EventsList.js